/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AppRpc
 */
import * as References from './AppRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AppRpc#listSupportedApps
 */
export const LIST_SUPPORTED_APPS_QUERY_FIELD_NAME = 'com_hubspot_unifiedaccount_rpc_AppRpc_listSupportedApps';
export const LIST_SUPPORTED_APPS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_SUPPORTED_APPS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.listSupportedAppsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});